import { fetchWithAuth, getCSRFToken } from '../auth';

const API_HOST = process.env.REACT_APP_ICC_TOOL_API_HOST;

const readOpts = () => ({
    headers: { 'X-CSRFToken': getCSRFToken() },
    credentials: 'include',
});

const writeOpts = (method, body) => ({
    method,
    headers: { 'Content-Type': 'application/json', 'X-CSRFToken': getCSRFToken() },
    credentials: 'include',
    body: JSON.stringify(body),
});

const throwIfNotOk = async (resp, fallback) => {
    if (!resp.ok) {
        const err = await resp.json().catch(() => ({}));
        throw Object.assign(new Error(err.detail || fallback), { fieldErrors: err });
    }
};

export async function getFormChecklists() {
    const resp = await fetchWithAuth(`${API_HOST}form-checklists/`, readOpts());
    if (!resp.ok) throw new Error('Failed to fetch form checklists.');
    return resp.json();
}

export async function getFormChecklist(id) {
    const resp = await fetchWithAuth(`${API_HOST}form-checklists/${id}/`, readOpts());
    if (!resp.ok) throw new Error('Failed to fetch form checklist.');
    return resp.json();
}

export async function createFormChecklist(data) {
    const resp = await fetchWithAuth(`${API_HOST}form-checklists/`, writeOpts('POST', data));
    await throwIfNotOk(resp, 'Failed to create form checklist.');
    return resp.json();
}

export async function updateFormChecklist(id, data) {
    const resp = await fetchWithAuth(`${API_HOST}form-checklists/${id}/`, writeOpts('PUT', data));
    await throwIfNotOk(resp, 'Failed to update form checklist.');
    return resp.json();
}

export async function patchFormChecklist(id, data) {
    const resp = await fetchWithAuth(`${API_HOST}form-checklists/${id}/`, writeOpts('PATCH', data));
    await throwIfNotOk(resp, 'Failed to save form checklist.');
    return resp.json();
}

export async function deleteFormChecklist(id) {
    const resp = await fetchWithAuth(`${API_HOST}form-checklists/${id}/`, {
        method: 'DELETE',
        headers: { 'X-CSRFToken': getCSRFToken() },
        credentials: 'include',
    });
    if (!resp.ok) {
        const err = await resp.json().catch(() => ({}));
        throw new Error(err.detail || 'Failed to delete form checklist.');
    }
}
